import type { InterventionTemplatesListTableRowActionsProps } from "./intervention-templates-list-table-row-actions.type";

import InterventionTemplateEdit from "@/features/InterventionTemplates/InterventionTemplateEdit";
import { InterventionTemplateDuplicateButton } from "@/modules/intervention-template/intervention-template-duplicate";
import { useListTableRowActions } from "@/modules/list-table-row-actions";
import ModelDeleteButton from "@/modules/model-delete-button";
import ModelEditButtonLegacy from "@/modules/model-edit-button-legacy";
import ModelViewButton from "@/modules/model-view-button";

const InterventionTemplatesListTableRowActions = ({
  template,
}: InterventionTemplatesListTableRowActionsProps) => {
  const { closePopover } = useListTableRowActions();

  return (
    <>
      <ModelViewButton
        type="text"
        modelKey="interventiontemplate"
        item={template}
        onClick={closePopover}
      />
      <ModelEditButtonLegacy
        type="text"
        modelKey="interventiontemplate"
        item={template}
        component={<InterventionTemplateEdit templateId={template.id} />}
        onClick={closePopover}
      />
      <InterventionTemplateDuplicateButton
        type="text"
        template={template}
        onClick={closePopover}
      />
      <ModelDeleteButton
        type="text"
        modelKey="interventiontemplate"
        item={template}
        disabled={!template.is_deletable}
        onClick={closePopover}
        hideIcon
      />
    </>
  );
};

export default InterventionTemplatesListTableRowActions;
